
export default function GalleryCTA() {
  const handleGetQuote = () => {
    window.REACT_APP_NAVIGATE('/booking');
  };

  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-4">Get Started</p>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          Ready to Transform Your Space?
        </h2>
        <p className="text-lg text-gray-600 mb-10 leading-relaxed">
          Let us bring your vision to life with the same quality and attention to detail you see in our gallery. Contact us today for a free consultation and quote.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={handleGetQuote}
            className="px-8 py-4 bg-amber-600 text-white font-semibold rounded-lg hover:bg-amber-700 transition-colors duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Your Free Quote
          </button>
          <a
            href="tel:07951413307"
            className="px-8 py-4 bg-sky-600 text-white font-semibold rounded-lg hover:bg-sky-700 transition-colors duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            Call Us Now
          </a>
        </div>
      </div>
    </section>
  );
}
